import { Hit, TransformedHit } from "../../../store/ProductStore"

export function transformHit(hit: Hit, selectedPriceDay?: number, selectedStoreId?: string|null, selectedRegion?: number): TransformedHit {
  const defaultPrice = hit.global_price as string
  let dailyPrice = null

  // Start with assumption that product is not available
  let availableForDayAtStore = false

  // default store to Store zero if not set/passed in
  if(!selectedStoreId) selectedStoreId = '0'

  // Map the global in_stock flag(Depending on if it came from Algolia or SFCC - needs aligning)
  const inStock = hit.in_stock || hit.inStock || false

  // If we are in-stock at global level, and have a day selected, check in store availability for that day
  if (inStock && selectedPriceDay !== undefined && selectedPriceDay !== null) {
    const priceForDay = hit.matrixPrices && selectedRegion !== undefined ? hit.matrixPrices?.[selectedPriceDay]?.[selectedRegion] : null
    // If selected store is NOT in the array, we can assume available
    if(priceForDay !== null && hit.matrixAvailability[selectedPriceDay] && !hit.matrixAvailability[selectedPriceDay].includes(selectedStoreId)){
      availableForDayAtStore = true
    }
    // Set the Daily Price
    dailyPrice = hit.default_price_per_day?.[selectedPriceDay as keyof typeof hit.default_price_per_day] as unknown as string
  }

  // Set the displayPrice
  const displayPrice = dailyPrice || defaultPrice

 return {...hit, defaultPrice, dailyPrice, displayPrice, availableForDayAtStore}
}
